export { SettingsModule } from './SettingsModule'
export const settingsPath = '/et/company/:companyId/configuration'
